<!--
 * @Author: Lemon C
 * @Date: 2024-05-13 17:34:21
 * @LastEditTime: 2026-01-28 10:44:41
-->
<template>
    <div class="sup-update-comp">
        <div class="update-top-box">
            <span class="update-top-tip">近期重要更新</span>
            <div class="updata-top-version-box">
                <el-dropdown trigger="click" placement="bottom">
                    <el-button class="version-btn">
                        历史版本<el-icon><arrow-down /></el-icon>
                    </el-button>
                    <template #dropdown>
                        <el-dropdown-menu class="version-drop-menu">
                            <el-dropdown-item v-for="item in update_version_list" :key="item.id" @click="eldropdown_item_click(item)">
                                {{ item.title }}
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </template>
                </el-dropdown>
            </div>
        </div>
        <div class="update-list-box">
            <div class="list-item-box" v-for="(item, index) in update_version_list" :key="index">
                <span class="item-title" :id="`${item.id}`">{{ version_name(item) }}</span>
                <span class="item-time">{{ item.displayTime }}</span>
                <span class="item-tip">更新日志</span>
                <div class="item-md" @click="md_handle_link_click">
                    <md-preview :editorId="md_preview_id" :modelValue="item.content" previewTheme="github" :codeFoldable="false" />
                    <!-- <md-preview :editorId="md_preview_id" :modelValue="md_content_computed(item.content)"
                        previewTheme="github" :codeFoldable="false" /> -->
                </div>
                <div class="item-btn-list">
                    <div
                        :class="downloadBtn_class(item)"
                        @click="item_btn_download(item)"
                        v-if="comp_tree_node_tree_type !== $globalObj.docs_update_type.platform && item.accessory.length > 0">
                        <img class="item-img" src="@/assets/imgs/general/icon_download.png" />
                        <span class="item-name">{{ btn_name(item) }}</span>
                    </div>
                    <div class="item-btn" @click="item_btn_download_doc(item)" v-if="item.operationManual.length > 0">
                        <img class="item-img" src="@/assets/imgs/general/icon_download.png" />
                        <span class="item-name">文档</span>
                    </div>
                </div>
                <div class="item-line"></div>
            </div>
        </div>
    </div>
</template>

// MOD-- JavaScript
<script setup>
import { ref, onMounted, watch, getCurrentInstance, computed, nextTick } from 'vue';
import { MdPreview } from 'md-editor-v3';
import 'md-editor-v3/lib/preview.css';

import { getDocumentListByDcId } from '@/service/interface';
import { formatTime_YMD, compareTime } from '@/utils/generalMethods';
import { useRouterStore } from '@/stores/router';

const router_store = useRouterStore();
const { proxy } = getCurrentInstance();

const props = defineProps({
    share_url_data: Object, // 链接分享数据
    comp_tree_node_id: String,
    comp_tree_node_name: String,
    comp_tree_node_tree_type: String,
});

const md_preview_id = ref('preview-only');
const update_version_list = ref([]);
// const hlkeys = ref([]);

const version_name = computed(() => {
    return function (item) {
        let titleStr = '';
        if (props.comp_tree_node_tree_type === proxy.$globalObj.docs_update_type.sdk) {
            titleStr = 'BlackHole Engine SDK_' + item.title;
        } else {
            titleStr = props.comp_tree_node_name + '_' + item.title;
        }
        return titleStr;
    };
});

const btn_name = computed(() => (item) => {
    if (props.comp_tree_node_tree_type == proxy.$globalObj.docs_update_type.sdk) {
        return 'SDK';
    } else if (props.comp_tree_node_tree_type == proxy.$globalObj.docs_update_type.plugin) {
        return '安装包';
    } else if (props.comp_tree_node_tree_type == proxy.$globalObj.docs_update_type.client) {
        return '安装包';
    } else {
        return '资源';
    }
});

const downloadBtn_class = computed(() => (item) => {
    let btn_class = 'item-btn';
    if (props.comp_tree_node_tree_type == proxy.$globalObj.docs_update_type.plugin && item.accessory.length > 0) {
        if (compareTime(item.displayTime, '2026-01-01') !== 2) {
            btn_class += ' item-btn-disabled'; // 徐哥要求2026-01-01之前上传的都无效
        }
    }
    return btn_class;
});

// const md_content_computed = computed(() => (content) => {
//     return highlightText(content, hlkeys.value);
// });

// const highlightText = (text, keywords) => {
//     // 首先按关键词长度降序排序
//     const sortedKeywords = keywords.sort((a, b) => b.length - a.length);
//     let highlighted = text;
//     sortedKeywords.forEach((keyword) => {
//         // 使用正则表达式替换，确保不会替换已经被高亮的部分
//         // 注意这里使用了(?<!...)和(?!...)来避免替换已经被高亮的部分
//         const regex = new RegExp(`(?<!</span>)${escapeRegExp(keyword)}(?!</span>)`, 'g');
//         highlighted = highlighted.replace(regex, `<span>${keyword}</span>`);
//     });
//     return highlighted;
// };

// const escapeRegExp = (string) => {
//     return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& 表示与整个匹配项相同的文本
// };

watch(
    () => props.comp_tree_node_id,
    (val) => {
        service_get_update();
    }
);

onMounted(() => {
    service_get_update();
});

// MARK Service  获取版本信息
const service_get_update = () => {
    if (!props.comp_tree_node_id || !props.comp_tree_node_id.length) {
        return;
    }
    let params = {
        dcid: props.comp_tree_node_id,
    };
    proxy.$showLoading();
    getDocumentListByDcId({ params }).then((res) => {
        proxy.$hideLoading();
        let result = res.data;
        if (Object.keys(result).length !== 0) {
            update_version_list.value = result.map((item) => {
                let displayTime = formatTime_YMD(new Date(item.displayTime));
                item.displayTime = displayTime;
                return item;
            });
            nextTick(() => {
                share_auto_loc();
            });
        } else {
            update_version_list.value = [];
        }
    });
};

// MARK Share 自动滚动定位
const share_auto_loc = () => {
    if (props.share_url_data && props.share_url_data.shareType == 1 && props.share_url_data.docId && props.share_url_data.docId.length) {
        const element = document.getElementById(props.share_url_data.docId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    }
};

// MARK el-dropdown-menu  点击
const eldropdown_item_click = (data) => {
    const element = document.getElementById(data.id);
    if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
    }
};
// MARK Btn  下载
const item_btn_download = (item) => {
    if (item.accessory === '') {
        proxy.$message.error('文件缺失，下载失败！');
        return;
    }
    if (props.comp_tree_node_tree_type == proxy.$globalObj.docs_update_type.plugin && item.accessory.length > 0) {
        if (compareTime(item.displayTime, '2026-01-01') !== 2) {
            return;
        }
    }
    window.open(`${window.downloadBaseUrl}/${item.accessory}`, '_blank');
};
// MARK Btn  下载文档
const item_btn_download_doc = (item) => {
    if (item.operationManual === '') {
        proxy.$message.error('文件缺失，下载失败！');
        return;
    }
    window.open(`${window.downloadBaseUrl}/${item.operationManual}`, '_blank');
};
// MARK Btn  查看pdf
const item_btn_pdf = (item) => {
    if (item.operationManual === '') {
        proxy.$message.error('文件缺失，读取失败！');
        return;
    }

    let routeData = proxy.$router.resolve({
        path: './pdfviewer',
        query: { pdfurl: item.operationManual },
    });
    window.open(routeData.href, 'none');
};

// MARK MD 处理链接点击
const md_handle_link_click = (event) => {
    const target = event.target;
    if (target.tagName === 'A') {
        event.preventDefault(); // 阻止默认的链接跳转行为
        const href = target.getAttribute('href');
        router_store.navigateToLinkHref(href);
    }
};
</script>

// MOD-- CSS
<style lang="less" scoped>
.sup-update-comp {
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    .update-top-box {
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 75px;
        background-color: var(--color-main-light-bg-white);
        z-index: var(--update-version-z-index);
        display: flex;
        align-items: center;
        justify-content: space-between;

        .update-top-tip {
            position: relative;
            width: 500px;
            margin-left: 40px;
            font-weight: 500;
            font-size: 28px;
            color: var(--color-main-text-primary);
            line-height: 41px;
        }

        .updata-top-version-box {
            position: relative;
            margin-right: 50px;

            .version-btn {
                width: 130px;
                padding: 9px 20px;

                .icon {
                    margin-left: 10px;
                }
            }
        }
    }

    .update-list-box {
        position: relative;
        width: 100%;
        display: flex;
        flex-direction: column;
        padding-left: 42px;
        padding-right: 20px;
        box-sizing: border-box;
        margin-top: 75px;
        height: calc(100% - 75px);
        overflow-y: auto;

        .list-item-box {
            position: relative;
            width: 100%;
            display: flex;
            flex-direction: column;
            margin-bottom: 20px;

            .item-title {
                font-weight: 500;
                font-size: 24px;
                color: var(--color-main-brand);
                line-height: 36px;
            }

            .item-time {
                margin-top: 12px;
                font-weight: 400;
                font-size: 20px;
                color: var(--color-main-brand);
                line-height: 29px;
            }

            .item-tip {
                margin-top: 24px;
                font-weight: 400;
                font-size: 20px;
                color: var(--color-main-text-primary);
                line-height: 29px;
            }

            .item-line {
                position: relative;
                margin-top: 27px;
                margin-right: 130px;
                height: 1px;
                background: var(--color-main-doc-segmentation-line-bg);
            }

            :deep(.item-md) {
                margin-top: 16px;
                margin-left: 20px;

                .md-editor-code-head {
                    background-color: var(--color-main-md-code-bg) !important;
                }

                .md-editor-code pre code {
                    background-color: var(--color-main-md-code-bg) !important;
                }

                .md-editor-preview-wrapper {
                    padding: unset !important;
                }

                .md-editor ::-webkit-scrollbar {
                    width: var(--scrollbar-width);
                }

                .md-editor ::-webkit-scrollbar-track {
                    background-color: var(--color-main-scrollbar-track-white);
                    border-radius: unset;
                }

                .md-editor ::-webkit-scrollbar-thumb {
                    border-radius: 4px;
                    background-color: var(--color-main-scrollbar-thumb);
                    box-shadow: var(--color-main-scrollbar-thumb-box-shadow);
                    -webkit-box-shadow: var(--color-main-scrollbar-thumb-box-shadow);
                }
            }

            .item-btn-list {
                position: relative;
                display: flex;
                margin-top: 10px;
                align-items: center;

                .item-btn {
                    position: relative;
                    width: 100px;
                    height: 38px;
                    margin-left: 20px;
                    background-color: var(--color-main-brand);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    border-radius: 4px;
                    box-shadow: 0px 2px 4px 0px rgba(194, 194, 194, 0.5);
                    cursor: pointer;
                    outline: 0 solid transparent;
                    transition: var(--animation-outline-style);

                    .item-img {
                        position: relative;
                        margin-right: 3px;
                        width: 16px;
                        height: 16px;
                    }

                    .item-name {
                        position: relative;
                        color: var(--color-main-text-brand-bg-primary);
                        font-size: 14px;
                    }

                    &:hover {
                        outline: 4px solid var(--color-main-outline-hover);
                    }

                    &:nth-child(1) {
                        margin-left: 20px;
                    }
                }

                .item-btn-disabled {
                    background-color: var(--color-main-text-disabled) !important;
                    cursor: not-allowed;
                }
            }
        }
    }
}

.version-drop-menu {
    min-width: 130px;
    max-height: 400px;
    overflow: auto;
    margin-left: -2px;
}
</style>
